export default {
  startPolling: false,
  requireTimer: null
}
